import { render, staticRenderFns } from "./SliderSkazki.vue?vue&type=template&id=1097188a&"
import script from "./SliderSkazki.vue?vue&type=script&lang=js&"
export * from "./SliderSkazki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports